// extracted by mini-css-extract-plugin
export var center = "_3k-2";
export var clickableRow = "_3k-5";
export var expandedRow = "_3k-7";
export var hoverable = "_3k-4";
export var left = "_3k-1";
export var right = "_3k-3";
export var row = "_3k-0";
export var selectedRow = "_3k-6";
export var summaryRow = "_3k-8";